import { Cell } from '@table-library/react-table-library/table';

import { contributorColumns } from '../GscTools/columns';
import { countryLabel, sourceLabel, sourceScope } from './sources';

/**
 * The columns this report defines on top of the shared GSC tool sets: a country column that reads
 * a returned key in words, and the table block 05 names the three sources in.
 */

/**
 * The country's own column: the readable name beside the key Search Console returned.
 *
 * The key is kept on screen, not replaced. It is what the filter a click applies is built from and
 * what the export carries, and a country this app has no name for is still shown as the code it
 * arrived as rather than disappearing behind an "unknown".
 */
function countryColumn(t) {
    return {
        label: t('tools.gsc.controls.country'),
        key: 'key',
        data: 'key',
        sortType: 'string',
        cellSize: 'minmax(220px, 2.4fr)',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            const label = countryLabel(data);
            if (label === data) return data;

            return (
                <span>
                    {label} <small className="text-muted">{data}</small>
                </span>
            );
        },
    };
}

/** Block 04 — one window of country rows: the country and its metrics as returned. */
export function countryColumns(t, { hasPosition }) {
    const shared = contributorColumns(t, { hasPosition, isUrl: false });
    return [countryColumn(t), ...shared.slice(1)];
}

/** Block 05 — the three surfaces, by the tab they are chosen under and the type they are sent as. */
export const SOURCE_COLUMNS = (t) => [
    {
        label: t('tools.discover_news.coverage.tab'),
        key: 'tab',
        data: 'tab',
        sortType: 'string',
        cellSize: 'minmax(170px, 1.2fr)',
        Component: Cell,
    },
    {
        label: t('tools.discover_news.coverage.api_type'),
        key: 'type',
        data: 'type',
        sortType: 'string',
        cellSize: 'minmax(140px, 1fr)',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <code className="gsc-tool-expression">{data}</code>,
    },
    {
        label: t('tools.discover_news.coverage.scope'),
        key: 'scope',
        data: 'scope',
        sortType: 'string',
        cellSize: 'minmax(260px, 2.4fr)',
        Component: Cell,
    },
];

/** The rows of that table, one per source, in the order the source select offers them. */
export function sourceRows(t, sources) {
    return sources.map((source) => ({
        id: source,
        tab: sourceLabel(t, source),
        type: source,
        scope: sourceScope(t, source),
    }));
}
